import styled from 'styled-components';
import {dFlexColumn} from '../../../../globalVariables/GlobalFlex';
import {tabletMedia} from '../../../../globalVariables/GlobalVariables';
import {getFontSize, getFontWeight, getSpacing} from '@tickchak/react-share/app';

export const title = styled.div`
    font-weight: ${getFontWeight('semibold')};
    font-size: ${getFontSize('body')};
`;

export const statsList = styled.div`
    ${dFlexColumn};
    gap: ${getSpacing('spaceLg')};
    
    ${tabletMedia} {
        padding: ${getSpacing('spaceXl')};
    }
`;

